// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__2r-GJ","list":"styles_list__2a3r_"};